import React from "react";
import ReactDOM from "react-dom/client";
import { App } from "./App.js";
import "./styles.css";

// Telegram Mini App init. Keep the app fully expanded so the keyboard doesn't
// leave a half-collapsed viewport that the owner then has to manually pinch
// back. Also disable the vertical-swipe-to-close gesture so accidental scrolls
// near the top don't kill the app mid-task.
const tg = (window as any).Telegram?.WebApp;
if (tg) {
  try {
    tg.ready();
    tg.expand();
    // Some Telegram clients (newer) — opt in if available.
    tg.disableVerticalSwipes?.();
    // Re-expand whenever the viewport changes (keyboard up/down).
    tg.onEvent?.("viewportChanged", () => {
      if (!tg.isExpanded) tg.expand();
    });
  } catch (e) {
    console.warn("[tg-init]", e);
  }
}

ReactDOM.createRoot(document.getElementById("root")!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
